import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { notificationStatus, notificationsTemplateStatusV2, notificationType, notificationTemplateStatusV2 } from '../../../../_enums';
import { bluePlusIcon, copyIcon, dotsVerticalIcon, editIcon, filterLinesIcon, icons, plusIcon, searchIcon } from '../../../../sharedcomp/constans/icons.constans';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { Observable, Subject, of } from 'rxjs';
import { CustomerService } from 'src/app/_services';
import { catchError, delay, finalize, switchMap, takeUntil, tap } from 'rxjs/operators';
import { AppConfig, DataService } from 'src/app/_helpers';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbdModalContent } from 'src/app/sharedcomp/ui-components/modals/modal-v1/modal-v1.component';
import { NotificationTemplate } from 'src/app/_models';

@Component({
  selector: 'app-template',
  templateUrl: './templates.component.html',
  styleUrls: [
    './templates.component.css',
    '../../../../../assets/css/new-component-view.css',
    '../../../../../assets/css/new-badges-chips-theme.css',
    '../../../../../assets/css/new-form-elements.css',
    '../../../../../assets/css/new-buttons-theme.css',
    '../../../../sharedcomp/sidebar/sidebar.component.css',
    '../../../../sharedcomp/ui-components/drpdowns/dropdown/dropdown.component.css'
  ],
  animations: [
    trigger('animationSplit', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(400px)' }),
        animate('500ms ease-out', style({ opacity: 1, transform: 'translateX(0)' })),
      ]),
      transition(':leave', [
        animate('500ms ease-in', style({ opacity: 1, transform: 'translateX(500px)' })),
      ]),
    ]),
    trigger('fadeInOut', [
      state('void', style({ opacity: 0 })),
      transition(':enter', [
        animate(200, style({ opacity: 1 })),
      ]),
    ])
  ]
})
export class TemplateComponent implements OnInit {

  @Input() customerPublicId: string;

  ddlnotificationTemplateType: notificationType['dbtType'];

  icons: Record<string, { path: string; alt: string }>;

  notificationTemplateTypeFormControl: FormControl = new FormControl('TODOS');
  templateStatusOptions: (typeof notificationsTemplateStatusV2);
  notificationTemplateStatusSelectedValue: notificationTemplateStatusV2 | 'TODOS' = 'TODOS';

  displayLoaderSpinner: boolean = false;
  dataSource: MatTableDataSource<any> = new MatTableDataSource([]);
  templateList: any[];
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] = ['data', 'type', 'status', 'actions'];
  pageSize: number;
  PageSizeOptions: number[];
  totalSize: number = 0;

  notificationTemplateList$: Observable<any>;

  templateListLimit: number = 100;
  searchFilterForm: FormGroup;
  typeFormControl: FormControl = new FormControl('TODOS');
  statusFormControl: FormControl = new FormControl('TODOS');

  notificationTemplateForm: FormGroup;

  searchValue: string = '';
  status: string = "TODOS";
  type: string = "TODOS";

  private destroy$ = new Subject<void>();

  constructor(
    private _notificationType: notificationType,
    private customerService: CustomerService,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private dataService: DataService
  ) {
    this.ddlnotificationTemplateType = this._notificationType.dbtType;

    this.pageSize = AppConfig.settings.gridPageSetting.PageSize;
    this.PageSizeOptions = AppConfig.settings.gridPageSetting.PageSizeOptions;
    this.icons = this.setIcons();
    this.templateStatusOptions = notificationsTemplateStatusV2;
    this.initSearchForm();
    this.initNotificationForm();
  }

  ngOnInit() {
    this.paginator._intl.itemsPerPageLabel = "Registros por página";
    this.paginator._intl.nextPageLabel = "siguiente página";
    this.paginator._intl.lastPageLabel = "última página";
    this.paginator._intl.previousPageLabel = "anterior página";
    this.paginator._intl.firstPageLabel = "primera página";
    this.setNotificationListObservable();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  goToForm(componentType: 'LIST' | 'CREATE-FORM' | 'EDIT-DUPLICATE-FORM', formType:"" | 'DUPLICATE' | 'EDIT' = "", publicId: string = null) {
    if (publicId != null && componentType === 'CREATE-FORM' || componentType === 'EDIT-DUPLICATE-FORM') {
      this.customerService.templateNotificationId = publicId;
    }
    this.customerService.templateNotificationFormType = formType;
    this.dataService.displayTemplateSection(componentType);
  }

  initNotificationForm() {
    this.notificationTemplateForm = this.formBuilder.group({
      id: new FormControl(0),
      name: new FormControl("", Validators.required),
      type: new FormControl("EMAIL"),
      status: new FormControl("ACTIVE"),
      header: new FormControl("", Validators.required),
      content: new FormControl("", Validators.required)
    });
  }

  updateNotificationProcess$(templateId: string, status: string) {
    return this.customerService.getIndNotificationTemplateDetail(templateId)
      .pipe(
        takeUntil(this.destroy$),
        tap((data: NotificationTemplate) => {
          this.notificationTemplateForm.patchValue({
            id: data.id,
            name: data.name,
            type: data.type,
            status: status,
            header: data.header,
            content: data.content
          });
        }),
        switchMap((data: NotificationTemplate) => this.updateNotification$(templateId, this.notificationTemplateForm.value)),
        catchError(error => {
          console.error('Failed while trying to get notification details.' + error);
          this.dataService.loadSpinner(false);
          return of(null);
        })
      );
  }

  updateNotification$(templateId: string, notificationTemplateForm: FormGroup) {
    return this.customerService.updateNotificationTemplate(templateId, notificationTemplateForm)
      .pipe(
        takeUntil(this.destroy$),
        catchError(error => {
          console.error('Failed while trying to update notification.' + error);
          this.dataService.loadSpinner(false);
          return of(null);
        })
      )
  }

  open(): Promise<boolean> {
    const modalRef = this.modalService.open(NgbdModalContent, { centered: true, windowClass: 'custom-modal-width' });
    modalRef.componentInstance.bodyTextTittle = '¿Quieres desactivar esta plantilla?';
    modalRef.componentInstance.bodyTextParagraph = 'Cuando desactiva una plantilla, no se puede utilizar en programación de notificaciones';
    modalRef.componentInstance.dismissButton = 'Mantener la plantilla activa';
    modalRef.componentInstance.acceptButton = 'Desactivar plantilla';

    return modalRef.result.then(
      (result) => true,
      (reason) => false
    );
  }

  validateChange(element: any): Promise<boolean> {
    return this.open();
  }

  updateStatus(element, newStatus: notificationTemplateStatusV2["value"]) {
    this.dataService.loadSpinner(true);
    this.updateNotificationProcess$(element.public_id, newStatus)
      .pipe(
        tap(data => {
          if (data != null) {
            element.status = data.status;
            this.dataService.loadSpinner(false);
          }
        })
      )
      .subscribe();
  }

  onCheckboxClick(event, element) {
    event.preventDefault();
    const newStatus = this.setNewStatus(element.status);

    if (element.status === 'ACTIVE') {
      this.validateChange(element)
        .then((isValid) => {
          if (isValid) {
            this.updateStatus(element, newStatus);
          }
        });
    } else {
      this.updateStatus(element, newStatus);
    }
  }

  setNewStatus(type: 'ACTIVE' | 'INACTIVE') {
    return type === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';
  }

  setIcons() {
    return {
      bluePlus: bluePlusIcon,
      searchIcon: searchIcon,
      filterLines: filterLinesIcon,
      dotsVertical: dotsVerticalIcon,
      edit: editIcon,
      copy: copyIcon
    };
  }

  initSearchForm() {
    this.searchFilterForm = this.formBuilder.group({
      searchTextFormControl: ['']
    });
  }

  applyFilter() {
    this.searchValue = this.searchFilterForm.controls.searchTextFormControl.value.trim().toLowerCase();
    this.filter();
    this.paginator.firstPage();
  }

  filter() {
    let tempFilterData = this.templateList || [];
    if (this.status !== "TODOS") {
      tempFilterData = tempFilterData.filter(data => data.status === this.status)
    }

    if (this.type !== "TODOS") {
      tempFilterData = tempFilterData.filter(data => data.type === this.type)
    }

    const searchText = (this.searchFilterForm.controls.searchTextFormControl.value || '').trim();
    if (searchText.length > 0) {
      tempFilterData = tempFilterData.filter(data => (data.name || '').toLowerCase().includes(searchText.toLowerCase()))
    }

    this.dataSource.data = tempFilterData;
  }

  setNotificationListObservable() {
    this.displayLoaderSpinner = true;
    this.dataService.loadSpinner(true);
    this.notificationTemplateList$ = this.customerService.getCustomerNotificationTemplateList(this.customerPublicId, this.templateListLimit)
      .pipe(
        takeUntil(this.destroy$),
        tap(data => {
          let resources = data || [];
          this.templateList = resources;
          this.dataSource.data = resources;
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.totalSize = resources.length;
          this.displayLoaderSpinner = false;
          this.dataService.loadSpinner(false);
        }),
        catchError(err => {
          console.error('Failed while trying to get customer notification template list. ' + err);
          this.dataService.loadSpinner(false);
          this.displayLoaderSpinner = false;
          return of(null)
        })
      )
  }

  selectNotificationTypeOption(option: string) {
    this.notificationTemplateTypeFormControl.setValue(option);
    this.filterTypeDetails(option);
  }

  filterTypeDetails(type) {
    this.type = type != null ? type : 'TODOS';
    this.filter();
    this.paginator.firstPage();
  }

  filterStatusDetails(status: notificationTemplateStatusV2["value"] | 'TODOS') {
    this.status = status != null ? status : 'TODOS';
    this.filter();
    this.paginator.firstPage();
  }

  selectStatusOption(option: notificationTemplateStatusV2["value"] | 'TODOS') {
    const filteredNotificationByType = this.templateStatusOptions.filter(el => el.value === option);
    this.notificationTemplateStatusSelectedValue = filteredNotificationByType.length > 0 ? filteredNotificationByType[0] : 'TODOS';
    this.filterStatusDetails(option);
  }

  get filterTypeName(): string {
    const filterType = this.ddlnotificationTemplateType.find(item => item.value === this.notificationTemplateTypeFormControl.value);
    return filterType ? filterType.name : '';
  }

}
